import type {FC} from 'react'
import {useTimeIntervalContext} from '@shared/providers/TimeIntervalProvider'
import {usePublishPageContext} from './PageContextProvider'
import {intervalTimeRange} from './routeFallback'
import type {PublishedPageContext} from './types'

/**
 * Publishes `context` with the time window of the enclosing TimeIntervalProvider.
 * For pages that mount that provider in their own JSX and so cannot read it where
 * they know their ids. Renders nothing.
 */
const PublishIntervalPageContext: FC<{context: PublishedPageContext}> = ({context}) => {
  const interval = useTimeIntervalContext()
  usePublishPageContext({
    ...context,
    time_range: interval
      ? intervalTimeRange(interval.startTime, interval.endTime, interval.timeRange)
      : context.time_range,
  })
  return null
}

export default PublishIntervalPageContext
